module.exports = "././img/arialbd.ttf";


//////////////////
// WEBPACK FOOTER
// ../assets/fonts/arial/arialbd.ttf
// module id = 809
// module chunks = 0